<template>
  <div class="platform-login">
    <el-carousel :interval="2000"
                 indicator-position="none">
      <el-carousel-item v-for="(item,index) in platformData.images?platformData.images.split(','):swiperList"
                        :key="index"
                        :arrow="swiperList.length>1?'hover':'never'"
                        style="cursor: pointer;"
                        @click.stop.native="jumpUrl(item)">
        <el-image :src="item.img||item"
                  style="width: 100%;"
                  fit="cover" />
      </el-carousel-item>
    </el-carousel>
    <div class="platform-content">
      <div class="platform-title">{{ $t('platformLogin.interHospital') }}</div>
      <div class="platform-btn">
        <div v-for="(item,index) in platformLoginList"
             :key="index"
             class="platform-box"
             @click="handleJump(item)">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeApi } from '@/api/homeApi'
import { commonApi } from '@/api/commonApi'
import { platformLoginObj } from '@/const/crud/list'
import { vaildatePc } from '@/commonModule/utils/validate'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  data () {
    return {
      swiperList: [],
      platformLoginList: platformLoginObj.platformList
    }
  },
  computed: {
    ...mapGetters(['platformData'])
  },
  mounted () {
    this.$store.dispatch('fetchPlatformData', { index: 3, endType: 4 }).then(res => {
      if (res.hospitalCode) this.hospitalCode = res.hospitalCode
    })
    this.fetchSwiperData()
  },
  methods: {
    async fetchSwiperData () {
      try {
        const res = vaildatePc() ? await homeApi.fetchSwiper() : await homeApi.fetchMobileSwiper({ type: 4 })
        this.swiperList = res.data.data.banner.filter(item => {
          return item.status == 1 || (item.status == 2 && +new Date(item.start_time) <= +new Date())
        })
      } catch (err) {
        console.error(err)
      }
    },
    jumpUrl (item) {
      if (item.url_type != 3 && item.url) {
        window.open(item.url, '_blank')
      }
    },
    async handleJump ({ index, endType }) {
      try {
        if (!this.hospitalCode) {
          this.$message.error('未配置，请联系管理员')
          return
        }
        const res = await commonApi.fetchPlatformPageData({
          index,
          hospitalCode: this.hospitalCode,
          endType
        })
        const data = res.data.payload.data && res.data.payload.data.length > 0 ? res.data.payload.data[0] : {}
        if (!data.domainUrl || !data.jumpUrl) {
          this.$message.error('未配置，请联系管理员')
          return
        }
        window.open(`${data.jumpUrl}${data.domainUrl}`, '_blank')
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixin.scss';

.el-row {
  @include wrap-flex;
}
.common-title {
  @include title-big;
  margin-bottom: 0.5vw;
}

/deep/ .el-carousel__container {
  height: 31.25vw;
}

.platform-login {
  text-align: center;
  .platform-title {
    margin-top: 30px;
    margin-bottom: 50px;
    font-size: 22px;
  }
  .platform-btn {
    display: flex;
    justify-content: center;
    .platform-box {
      width: 280px;
      height: 60px;
      line-height: 60px;
      border: 1px solid #979797;
      border-radius: 12px;
      font-size: 18px;
      margin-right: 32px;
      cursor: pointer;
      &:hover {
        background-color: #2d85ee;
        border: 1px solid #2d85ee;
        color: #fff;
      }
    }
  }
}
</style>
